import React, { useState, useEffect } from 'react'
import { HashRouter as Router, Switch, Route } from "react-router-dom";

import localStorageService from './components/localStorageService';
import Docs from './Docs';
import Home from './Home';

const App = () => {
  if(localStorageService.getItem("mdfile")==null){
    localStorageService.setItem("mdfile","welcome.md")
  }else{

  }
  if(localStorageService.getItem("loading")==null){
  localStorageService.setItem("loading",false)
  }
  else{
    
  }
  return (
    <div>
      
      <Switch>
          <Route exact path="/docs" ><Docs/></Route>
          <Route exact path="/"  ><Home/></Route>
          <Route>404 Not found!</Route>
      </Switch>
      
    </div>

    
  );
};

export default App;
